import { emitConnectorCatalogChanged } from '#pplx/frontend/apps/ask/connectors/events/connectorCatalogEvents.js';
import { PIPEDREAM_ACCOUNTS_QUERY_KEY, PIPEDREAM_CONNECTIONS_QUERY_KEY, } from '#pplx/frontend/apps/ask/connectors/hooks/pipedream/usePipedreamAccounts.js';
import { emitConnectorDisconnect } from '#pplx/frontend/apps/ask/connectors/hooks/useConnectorDisconnectEvents.js';
import { removeUserConnection } from '#pplx/frontend/apps/ask/hooks/connectors-hooks/utils/disconnect.js';
import { disconnectConnection, disconnectConnector, disconnectFileConnectorAndDeleteFiles, } from '#pplx/frontend/apps/ask/queries/mutations/connectorMutations.js';
import { getPluginDiscoverKey } from '#pplx/frontend/apps/ask/queries/query-keys/pluginKeys.js';
import { getSourcesQueryKeyPrefix } from '#pplx/frontend/apps/ask/queries/query-keys/sourcesKeys.js';
import { getUserSettingsQueryKey } from '#pplx/frontend/apps/ask/queries/query-keys/userKeys.js';
import { useMutation, useQueryClient } from '@tanstack/react-query';
export function useDisconnectConnector({ reason, onSuccess: onSuccessCallback, }) {
    const queryClient = useQueryClient();
    const queryKey = getUserSettingsQueryKey();
    return useMutation({
        mutationKey: ['publishArticleMutation'],
        mutationFn: async ({ connectorName, connectionUUID, deleteFiles, }) => {
            if (connectionUUID && !deleteFiles) {
                return await disconnectConnection({
                    connectionUUID,
                    reason,
                });
            }
            else if (connectionUUID && deleteFiles) {
                return await disconnectFileConnectorAndDeleteFiles({
                    connectionUUID,
                    reason,
                });
            }
            else {
                return await disconnectConnector({
                    connectorName,
                    reason,
                });
            }
        },
        onSuccess: (_data, variables) => {
            emitConnectorCatalogChanged({ sourceId: variables.connectorName });
            onSuccessCallback?.();
            void queryClient.invalidateQueries({ queryKey: getSourcesQueryKeyPrefix() });
            void queryClient.invalidateQueries({ queryKey: getPluginDiscoverKey() });
        },
        onSettled: async () => {
            await Promise.all([
                queryClient.refetchQueries({ queryKey: queryKey }),
                queryClient.invalidateQueries({ queryKey: PIPEDREAM_ACCOUNTS_QUERY_KEY }),
                queryClient.invalidateQueries({ queryKey: PIPEDREAM_CONNECTIONS_QUERY_KEY }),
            ]);
        },
        onMutate: async ({ connectorName, connectionUUID }) => {
            queryClient.setQueryData(queryKey, (oldData) => {
                if (!oldData) {
                    return oldData;
                }
                const newConnectors = oldData.connectors.connectors.map((connector) => {
                    if (connector.name === connectorName &&
                        (!connectionUUID || connector.connection_uuid === connectionUUID)) {
                        return { ...connector, connected: false };
                    }
                    return connector;
                });
                return { ...oldData, connectors: { connectors: newConnectors } };
            });
            await queryClient.cancelQueries({ queryKey: getSourcesQueryKeyPrefix() });
            queryClient.setQueriesData({ queryKey: getSourcesQueryKeyPrefix(), exact: false }, (oldData) => {
                if (!oldData || !oldData.pages)
                    return oldData;
                return {
                    ...oldData,
                    pages: oldData.pages.map((page) => removeUserConnection(page, { connectorName, connectionUUID }) ?? page),
                };
            });
            emitConnectorDisconnect({ sourceId: connectorName });
        },
    });
}
//# sourceMappingURL=useDisconnectConnector.js.map